import 'core-js';
import 'whatwg-fetch';

import Platform from './modules/remarkable/platform';

const R = new Platform();
R.init();
